export default __webpack_public_path__ + "static/media/canteen-1.bffa145e.jpg";